import { useState } from "react";
import { db } from '../config/firebase'
import { collection, addDoc } from 'firebase/firestore'



const UserInput = () => {
    const [ link, setLink ] = useState('')
    const [isValid, setIsValid] = useState(false)

    const dataCollectionRef = collection(db, 'lost-link')

    const handleSubmit = async (e) => {
        e.preventDefault()

        const linkRegex = /^(ftp|http|https):\/\/[^ "]+$/;

        await addDoc(dataCollectionRef, { link: link })
        
        // setIsValid(linkRegex.test(link))
        if (!linkRegex.test(link)) {
            setIsValid(false);
            return;
        }
        setLink('')

        alert('Link Thrown in ocean successfully!')
        window.location.reload()
    }


    return <section id="user_input" className="bg-slate-400 w-full py-4 px-2 text-center">
        <form className="flex justify-center items-center"
            onSubmit={handleSubmit}
        >
                <input type="url" placeholder="Enter Link..." required 
                className=" nes-input outline-none"
                value={link}
                onChange={(e) => setLink(e.target.value)}
            />

            <button type="submit" className="nes-btn is-primary uppercase">throw</button>
            {!isValid && <p className="nes-text is-warning capitalize">Please enter a valid link!</p>}

        </form>
    </section>
}

export default UserInput;